export { analyticsPath } from "./resultAnalytics.ts";

export type SeasonLiveResults = {
  unitId: string; version: number; preliminary: true; serverTimeEpochMillis: number; roundCount: number;
  resultsStatus: "AVAILABLE" | "NO_PARTICIPATION" | "NOT_READY" | "INCOMPLETE" | "UNAVAILABLE";
  unavailableReason?: string; policyBasis?: "ROUND_WEIGHTS" | "SAVED_RESULT_POLICY";
  items: { entryId: string; partyId?: string; displayName: string; score: string; rank: number | null }[];
};

/** Reject stale scope, malformed scores and partial unavailable responses before drawing a chart. */
export function validatedSeasonLiveResults(value: unknown, unitId: string, minimumVersion: number): SeasonLiveResults | undefined {
  if (!value || typeof value !== "object") return;
  const data = value as SeasonLiveResults;
  if (data.unitId !== unitId || !Number.isSafeInteger(data.version) || data.version < minimumVersion || data.preliminary !== true ||
    !Number.isSafeInteger(data.serverTimeEpochMillis) || data.serverTimeEpochMillis <= 0 || !Number.isSafeInteger(data.roundCount) ||
    data.roundCount < 0 || data.roundCount > 32 || !Array.isArray(data.items) || data.items.length > 1000 ||
    !["AVAILABLE", "NO_PARTICIPATION", "NOT_READY", "INCOMPLETE", "UNAVAILABLE"].includes(data.resultsStatus)) return;
  const scored = ["AVAILABLE", "NO_PARTICIPATION"].includes(data.resultsStatus);
  if (!scored) return data.items.length === 0 ? data : undefined;
  if (data.roundCount === 0 || data.items.length === 0 || !["ROUND_WEIGHTS", "SAVED_RESULT_POLICY"].includes(data.policyBasis || "")) return;
  const ids = new Set<string>();
  for (const row of data.items) {
    if (!row || typeof row.entryId !== "string" || !row.entryId || ids.has(row.entryId) || typeof row.displayName !== "string" ||
      typeof row.score !== "string" || !/^\d+(?:\.\d+)?$/.test(row.score) || !Number.isFinite(Number(row.score)) || Number(row.score) > 100) return;
    ids.add(row.entryId);
    if (data.resultsStatus === "NO_PARTICIPATION" ? row.rank !== null || Number(row.score) !== 0
      : !Number.isSafeInteger(row.rank) || row.rank! < 1 || row.rank! > data.items.length) return;
  }
  return data;
}
